import dropdown from "./dropdown";

const productsSort = (filterDropdown = '.js-filter-dropdown', container = '.js-filter-container', loadMore = '.js-posts-download') => {
    dropdown(filterDropdown, () => {
        runSort(1, (response)=> {
            console.log('Response from initial sort:', response);  // Log initial sort response
            $(container).html(response);
            $(loadMore).show();
            $(loadMore).attr('data-page', 0);
        });
    });

    $(loadMore).click(function(ev) {
        let target = $(ev.currentTarget),
            currentPage= +target.attr('data-page'),
            max = +target.attr('data-max');

        target.attr('disabled', 'true');
        if(currentPage < max){
            let next = currentPage + 1;
            runSort(next + 1, (response)=> {
                console.log('Response from load more:', response);
                $(container).append(response);
                target.attr('data-page', next);
                target.removeAttr('disabled');

                if(next === max ) {
                    target.hide();
                }
            })
        }
    });

    function runSort(page, cb) {
        let activeItem = $(filterDropdown).find('li.active'),
            order = activeItem.data('order'),
            orderby = activeItem.data('orderby'),
            meta =  activeItem.data('meta')?  activeItem.data('meta') : 0,
            termSlug =  $(filterDropdown).data('term'),
            perPage = $(loadMore).data('per-page');

        let data = {
            action: 'posts_load_more',
            termSlug: termSlug,
            order: order,
            orderby: orderby === 'product_price' ? 'meta_value_num' : orderby,
            meta : orderby === 'product_price' ? '_product_price_numeric' : meta,  // use 'product_price_numeric' instead of 'product_price'
            paged : page,
            perPage: perPage,
            postType:  'products',
            taxonomy : 'products-category',
        };

        console.log('Sending AJAX request with data:', data);  // Log data being sent in AJAX request

        $.ajax({
            type: 'POST',
            url: ajax_url[0],
            dataType: "html",
            data: data,
            success: function (response) {
                console.log('Successful AJAX response:', response);  // Log successful AJAX response
                cb(response);
            },
            error: function (error) {
                console.log('error', error);  // Existing error log
            }
        });
    }
};

export default productsSort;
